var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheckSolid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 115,
    viewBox: "0 0 100 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5714 0C32.5223 0 35.7143 3.19196 35.7143 7.14286V14.2857H64.2857V7.14286C64.2857 3.19196 67.4777 0 71.4286 0C75.3795 0 78.5714 3.19196 78.5714 7.14286V14.2857H89.2857C95.2009 14.2857 100 19.0848 100 25V35.7143H0V25C0 19.0848 4.79911 14.2857 10.7143 14.2857H21.4286V7.14286C21.4286 3.19196 24.6205 0 28.5714 0ZM0 42.8571H100V103.571C100 109.487 95.2009 114.286 89.2857 114.286H10.7143C4.79911 114.286 0 109.487 0 103.571V42.8571ZM73.4375 68.0804C75.5357 65.9821 75.5357 62.5893 73.4375 60.5134C71.3393 58.4375 67.9464 58.4152 65.8705 60.5134L44.6652 81.7188L34.1741 71.2277C32.0759 69.1295 28.683 69.1295 26.6071 71.2277C24.5312 73.3259 24.5089 76.7188 26.6071 78.7946L40.8929 93.0804C42.9911 95.1786 46.3839 95.1786 48.4598 93.0804L73.4375 68.0804Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 114.286,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheckSolid2);
export default __webpack_public_path__ + "static/media/calendar-check-solid 2.8a91388aa54dfd913f347320ca60cf52.svg";
export { ForwardRef as ReactComponent };